import React from "react";
import "../assets/css/main.css";
import { Link } from "react-router-dom";
import GSC_LOGO_New from "../assets/images/GSC_Logo_new.png";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="footer_bottom_main p-t-60">
          <div className="container-fluid">
            <div className="footer_bottom">
              <div className="row">
                <div className="col-sm-12 col-md-5 col-lg-3 col-xl-3">
                  <div className="footer_logo">
                    <Link to={"/"} className="navbar-brand">
                      <img src={GSC_LOGO_New} className="logo" alt="GSC Logo" />
                    </Link>
                    <div className="footer_logo_text">
                      <span>ગુજરાત રાજ્ય સંયુક્ત અને આરોગ્ય પરિષદ</span>
                      <span className="mt-2">
                        Gujarat State Allied and Healthcare Council
                      </span>
                    </div>

                    <div className="social_icons_box">
                      <span className="follow">Follow us</span>
                      <ul>
                        <li>
                          <a
                            href="https://www.facebook.com/"
                            target="_blank"
                            className="facebook"
                            title="Facebook"
                          >
                            <i className="fab fa-facebook-f"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.linkedin.com/"
                            target="_blank"
                            className="linkedin"
                            title="linkedin"
                          >
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://x.com/"
                            target="_blank"
                            className="twitter"
                            title="Twitter"
                          >
                            <i className="fab fa-twitter"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.youtube.com/"
                            target="_blank"
                            className="instagram"
                            title="YouTube"
                          >
                            <i className="fab fa-youtube"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-3 col-lg-2 col-xl-2">
                  <div className="footer_links">
                    <div className="footer_menu_main">
                      <h3>Quick Links</h3>
                      <ul>
                        <li>
                          <Link title="About Us" to={"/about-us"}>
                            About Us
                          </Link>
                        </li>
                        <li>
                          <Link to={"/members"} title="Members">
                            Members
                          </Link>
                        </li>
                        <li>
                          <Link to={"/professions"}>
                            Professions
                          </Link>
                        </li>
                        <li>
                          <Link title="Act & Rules" to={"/act-and-rules"}>
                            Act & Rules
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3">
                  <div className="footer_contact">
                    <h3>Our Office</h3>
                    <div className="office_add">
                      <div className="icon-box">
                        <i className="fas fa-map-marker-alt"></i>
                      </div>
                      <p>
                        GF, Opp. Post Office, Civil Hospital, Asarwa, Ahmedabad,
                        Gujarat 380016
                      </p>
                    </div>
                    <div className="office_phone">
                      <div className="icon-box">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.67998 1.3333C3.53775 1.15552 3.36886 1.06663 3.17331 1.06663C2.97775 1.06663 2.79109 1.13774 2.61331 1.27996L1.59998 2.2933C1.35109 2.54219 1.19109 2.82663 1.11998 3.14663C1.04886 3.46663 1.06664 3.76885 1.17331 4.0533C2.0622 6.57774 3.44886 8.78219 5.33331 10.6666C7.21775 12.5511 9.4222 13.9377 11.9466 14.8266C12.2311 14.9333 12.5333 14.9511 12.8533 14.88C13.1733 14.8089 13.4578 14.6489 13.7066 14.4L14.72 13.3866C14.8622 13.2089 14.9333 13.0222 14.9333 12.8266C14.9333 12.6311 14.8444 12.48 14.6666 12.3733L12.3733 10.56C12.1955 10.4177 12 10.3822 11.7866 10.4533L9.59998 10.9866C9.31553 11.0577 9.0222 11.0489 8.71998 10.96C8.41775 10.8711 8.15998 10.72 7.94664 10.5066L5.49331 8.0533C5.27998 7.83996 5.12886 7.58219 5.03998 7.27996C4.95109 6.97774 4.9422 6.68441 5.01331 6.39996L5.54664 4.2133C5.61775 3.99996 5.5822 3.80441 5.43998 3.62663L3.67998 1.3333ZM1.86664 0.533298C2.25775 0.142187 2.71109 -0.0355911 3.22664 -3.52859e-05C3.7422 0.0355206 4.15998 0.266631 4.47998 0.693298L6.29331 2.98663C6.47109 3.19996 6.58664 3.43996 6.63998 3.70663C6.69331 3.9733 6.68442 4.23108 6.61331 4.47996L6.07998 6.66663C6.00886 6.91552 6.0622 7.12885 6.23998 7.30663L8.69331 9.75996C8.87109 9.93774 9.08442 9.99107 9.33331 9.91996L11.52 9.38663C11.7689 9.31552 12.0266 9.30663 12.2933 9.35996C12.56 9.4133 12.8 9.52885 13.0133 9.70663L15.3066 11.52C15.7333 11.84 15.9644 12.2577 16 12.7733C16.0355 13.2889 15.8578 13.7422 15.4666 14.1333L14.4533 15.1466C14.0622 15.5377 13.6089 15.7955 13.0933 15.92C12.5778 16.0444 12.0711 16.0177 11.5733 15.84C8.90664 14.9155 6.56886 13.4489 4.55998 11.44C2.55109 9.43107 1.08442 7.0933 0.159976 4.42663C-0.0178022 3.92885 -0.0444689 3.42219 0.0799755 2.90663C0.20442 2.39108 0.462198 1.93774 0.853309 1.54663L1.86664 0.533298Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <a href="tel:07922684201" title="079 22684201">
                        079 22684201
                      </a>
                    </div>
                    <div className="office_mail">
                      <div className="icon-box">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0 4.00006C0 3.43117 0.195556 2.95117 0.586667 2.56005C0.977778 2.16894 1.45778 1.97339 2.02667 1.97339H14.0267C14.56 1.97339 15.0222 2.16894 15.4133 2.56005C15.8044 2.95117 16 3.43117 16 4.00006V12.0001C16 12.5689 15.8044 13.0401 15.4133 13.4134C15.0222 13.7867 14.5422 13.9734 13.9733 13.9734H2.02667C1.45778 13.9734 0.977778 13.7867 0.586667 13.4134C0.195556 13.0401 0 12.5689 0 12.0001V4.00006ZM2.02667 2.98672C1.74222 2.98672 1.50222 3.0845 1.30667 3.28006C1.11111 3.47561 1.01333 3.71561 1.01333 4.00006V4.21339L8 8.42672L14.9867 4.21339V4.00006C14.9867 3.71561 14.8889 3.47561 14.6933 3.28006C14.4978 3.0845 14.2756 2.98672 14.0267 2.98672H2.02667ZM14.9867 5.38672L10.2933 8.21339L14.9867 11.0934V5.38672ZM14.9867 12.2667L9.33333 8.80006L8 9.60006L6.66667 8.80006L1.01333 12.2667C1.08444 12.4801 1.20889 12.6578 1.38667 12.8001C1.56444 12.9423 1.77778 13.0134 2.02667 13.0134H14.0267C14.24 13.0134 14.4356 12.9423 14.6133 12.8001C14.7911 12.6578 14.9156 12.4801 14.9867 12.2667ZM1.01333 11.0934L5.70667 8.21339L1.01333 5.38672V11.0934Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <a
                        href="mailto:office@gsahc.in"
                        title="secretariat-secy@ncahp.mohfw.gov.i"
                      >
                        office@gsahc.in
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <div className="footer_map">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.2912521240496!2d72.6020098799693!3d23.049781425406508!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e841bd11f7e55%3A0x5fcd31fc673d3213!2sGujarat%20State%20Council%20For%20PhysioTherapy!5e0!3m2!1sen!2sin!4v1743166949072!5m2!1sen!2sin"
                      width="100%"
                      height="250"
                      style={{ border: 0 }}
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="copyright_main">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <span>Copyright © 2025 GSAHC All rights reserved. </span>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div className="footer_btm_links">
                    <ul>
                      <li>
                        <Link
                          title="Terms & Conditions"
                          to={"/terms-conditions"}
                        >
                          Terms & Conditions
                        </Link>
                      </li>
                      <li>
                        <Link title="Privacy Policy" to={"/privacy-policy"}>
                          Privacy Policy
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
